import { Layout } from "antd";
import styled from "styled-components";

const { Footer } = Layout;

export const AppFooter = styled(Footer)`
    text-align: center;
    background-color: white;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
`